import { render, staticRenderFns } from "./BaseWrapper.vue?vue&type=template&id=bb284d8e&scoped=true"
import script from "./BaseWrapper.vue?vue&type=script&lang=js"
export * from "./BaseWrapper.vue?vue&type=script&lang=js"
import style0 from "./BaseWrapper.vue?vue&type=style&index=0&id=bb284d8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb284d8e",
  null
  
)

export default component.exports